import { HttpAgent } from '@dfinity/agent';
import { IC_HOST } from '../config/icConfig';
import { StoicIdentity } from "ic-stoic-identity";

/**
 * 获取 agent 类型
 * @param agent
 */
export const getAgentType = (agent) => agent?.type_symbol;
// export const getAgentType = (agent: ExtAgent) => agent[TYPE_SYMBOL]

/**
 * 是否为 identity
 * @param agent
 */
export const isIdentityAgent = (agent) => 'identity' === getAgentType(agent);

/**
 * 是否为 plug
 * @param agent
 */
export const isPlugAgent = (agent) => 'plug' === getAgentType(agent);

/**
 * 是否为匿名 agent
 * @param agent
 */
export const isAnonymousAgent = (agent) => 'anonymous' === getAgentType(agent);


/**
 * 获取 agent
 * @param type
 * @param whitelist
 */
export const getAgent = (type, whitelist = [], autoLogin = true) => {
  if ('anonymous' === type) {
    return getAnonymousAgent({ host: IC_HOST });
  }  else if ('plug' === type) {
    // TODO 修改host为https://boundary.ic0.app测试第三方的canister
    return getPlugAgent({ host: IC_HOST, whitelist }, autoLogin);
  } else if ('stoic' === type) {
    return getStoicAgent({ host: IC_HOST })
  } else {
    throw new Error('UNSUPPORTED_AGENT_TYPE');
  }
};


const getStoicAgent = async(options = {})=>{

  const identity = StoicIdentity.load().then(async (identity) => {
    if (identity !== false) {
      //ID is a already connected wallet!
    } else {
      //No existing connection, lets make one!
      identity = await StoicIdentity.connect();
    }
    return identity
  })
  const agent = new HttpAgent({ identity, ...options });
    if (process.env.NODE_ENV === 'development') {
      await agent.fetchRootKey();
    }
  const extAgent = setAgentType(agent, 'stoic');
  return extAgent
}

/**
 * 获取匿名 agent
 */
const getAnonymousAgent = async (options = {}) => {
  return (async () => {
    // 创建http请求了
    const agent = new HttpAgent(options);
    if (process.env.NODE_ENV == 'development') {
      //await agent.fetchRootKey();
    }
    const extAgent = setAgentType(agent, 'anonymous');

    return extAgent;
  });
};

/**
 * 获取 identity agent
 */


/**
 * 获取 plug agent
 */
const getPlugAgent = async (options = {}, autoLogin) => {
  if (window.ic?.plug === undefined) {
    document.location = 'https://plugwallet.ooo/';
    // return
    throw new Error('INSTALL_PLUG_TIP');
  }
  const { plug } = window.ic;
  await plug.requestConnect({
    ...options,
    timeout: 60000,
  });

  const agent = plug.agent;
  if (process.env.NODE_ENV == 'development') {
    await agent.fetchRootKey();
  }
  // @ts-ignore
  const extAgent = setAgentType(agent, 'plug');
  return extAgent;
};

// @ts-ignore
const setAgentType = (agent, type) => {
  agent.type_symbol = type;
  const extAgent = agent;
  return extAgent;
};
